module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/adengiBannerImage-1138441fc449c90378c3862c7021b270.png";